<template>
  <form @submit.prevent="saveCompany" class="w-full">
    <div class="flex flex-col w-full" v-if="newCompany">
      <span class="border-b-2 w-full p-2 uppercase border-grey-academy-150
      bg-beige-academy-200" v-if="!addNewUnknownCompany">
        {{ newCompany.company_name }}, {{ newCompany.city}}, {{newCompany.country}}
      </span>
      <div v-else class="flex flex-col">
        <div class="flex justify-between items-center mt-3">
          <label for="school" class="w-1/3">{{$t('skills.company')}}:</label>
          <input type="text" id="school" v-model="newCompany.company_name" required
          class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200">
        </div>
        <div class="flex justify-between items-center mt-3">
          <label for="city" class="w-1/3">{{$t('skills.city')}}:</label>
          <input type="text" id="city" v-model="newCompany.city" required
          class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200">
        </div>
        <div class="flex justify-between items-center mt-3">
          <label for="state" class="w-1/3">{{$t('skills.province')}}:</label>
          <input type="text" id="state" v-model="newCompany.state"
          class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200">
        </div>
        <div class="flex justify-between items-center mt-3">
          <label for="country" class="w-1/3">{{$t('skills.nation')}}:</label>
          <input type="text" id="country" v-model="newCompany.country" required
          class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200">
        </div>
      </div>
      <div class="flex justify-between items-center mt-3">
        <label for="course" class="w-1/3">{{$t('skills.role')}}:</label>
        <input type="text" id="course" v-model="newCompanyData.role" required
        class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200">
      </div>
      <div class="flex justify-between items-center mt-3">
        <label for="years" class="w-1/3">{{$t('skills.start-year')}}:</label>
        <input type="text" id="years" v-model="newCompanyData.year_start"
        class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200"
        @keyup="resetErrorField('year_start')">
        <span class="text-red-500"
          v-if="errors.has('year_start')"
          v-text="errors.get('year_start')"
        >
        </span>
      </div>
      <div class="flex justify-between items-center mt-3">
        <label for="years" class="w-1/3">{{$t('skills.end-year')}}:</label>
        <input type="text" id="years" v-model="newCompanyData.year_end" v-if="!stillDoing"
          class="border-b-2 w-5/6 ml-2 p-2 border-grey-academy-150 bg-beige-academy-200"
          @keyup="resetErrorField('year_end')">
        <input type="text" id="years" v-model="newCompanyData.year_end" disabled v-else
          class="border-b-2 w-5/6 ml-2 p-2 border-grey-academy-150 bg-beige-academy-200">
        <span class="text-red-500"
          v-if="errors.has('year_end')"
          v-text="errors.get('year_end')"
        >
        </span>
        <div class="flex items-center w-1/5 justify-end">
          <input type="checkbox" id="during" v-model="stillDoing"
            @click="resetErrorField('year_end')">
          <label for="during" class="pl-2">{{$t('skills.still')}}</label>
        </div>
      </div>
      <div class="flex justify-between items-center mt-3">
        <label for="qualification" class="w-1/3">{{$t('skills.description')}}:</label>
        <textarea type="text" id="qualification" v-model="newCompanyData.description"
        class="border-b-2 w-full p-2 border-grey-academy-150 bg-beige-academy-200" />
      </div>
    </div>
    <div v-if="value && !newCompany" class="w-full">
      <auto-suggest-experience @selected="companySelected($event)"
      @empty="emptyAlgoliaExperiences = true" v-model="experienceDigit" />
    </div>
    <div class="w-full">
      <button class="w-auto bg-orange-academy-300 text-white p-2 rounded border
      hover:bg-white hover:text-orange-academy-300 border-orange-academy-300"
      @click.prevent="$emit('input', true)" v-if="!newCompany && !emptyAlgoliaExperiences">
        {{$t('skills.add-experience')}}
      </button>
      <div v-if="newCompany" class="flex items-center">
        <button class="w-auto bg-orange-academy-300 text-white p-2 rounded border mr-6
        hover:bg-white hover:text-orange-academy-300 border-orange-academy-300 mt-6"
        @click.prevent="reset" >
          {{$t('bookingSlots.cancel')}}
        </button>
        <button class="w-auto bg-orange-academy-300 text-white p-2 rounded border
        hover:bg-white hover:text-orange-academy-300 border-orange-academy-300 mt-6"
        type="submit" >
          {{$t('skills.save-exp')}}
        </button>
      </div>
      <div v-if="emptyAlgoliaExperiences && !newCompany && value"
      class="flex w-full justify-end items-center">
        {{$t('skills.sorry-work')}}
        <button class="w-auto bg-orange-academy-300 text-white p-2 rounded border
          hover:bg-white hover:text-orange-academy-300 border-orange-academy-300 ml-4"
          @click.prevent="addNewCompany" >
            {{$t('skills.add-company')}}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import Errors from '@/util/Errors';
import AutoSuggestExperience from '@/components/AutoSuggestExperience.vue';
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: ['value'],

  components: {
    AutoSuggestExperience,
  },

  data() {
    return {
      addNewUnknownCompany: false,
      newCompany: null,
      newCompanyData: {
        role: '',
        year_start: '',
        year_end: null,
        description: '',
      },
      stillDoing: false,
      experienceDigit: '',
      emptyAlgoliaExperiences: false,
      errors: new Errors(),
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  watch: {
    stillDoing() {
      if (this.stillDoing) {
        this.newCompanyData.year_end = null;
      }
    },
  },

  methods: {
    resetErrorField(field) {
      this.errors.clear(field);
    },
    companySelected(company) {
      this.newCompany = company.item;
    },

    addNewCompany() {
      this.addNewUnknownCompany = true;
      this.newCompany = {
        company_name: this.experienceDigit,
        city: '',
        state: '',
        country: '',
      };
    },

    saveCompany() {
      if (!this.newCompany.id) {
        axios.post('/api/work-experiences', this.newCompany).then(({ data }) => {
          this.newCompany = data;
          this.addTeacherCompany();
        });
        return;
      }
      this.addTeacherCompany();
    },

    addTeacherCompany() {
      axios.post(`/api/teachers/${this.user.teacher.id}/work-experiences/${this.newCompany.id}`, this.newCompanyData).then(() => {
        this.reset();
        this.$emit('experience-added');
      }).catch(({ response: { data: { errors } } }) => {
        this.errors.record(errors);
      });
    },

    reset() {
      this.$emit('input', false);
      this.addNewUnknownCompany = false;
      this.newCompany = null;
      this.newCompanyData = {
        role: '',
        year_start: '',
        year_end: null,
        description: '',
      };
    },

  },
};
</script>
